<template>
  <div class="ac-body-container">
    <div class="flex-row just-between">
      <div class="flex-column">
        <div class="ac-content-wrapper">
          <div class="sub-header">
            MyTech allows your customers to communicate with your technicians
            directly:
          </div>
        </div>
        <div class="ac-content-wrapper">
          <div class="filter-options">
            <div>
              <SACRadio
                name="handle-tech"
                field="isMyTech"
                value="yes"
                :checked="isMyTech === 'yes'"
                :change="onChange"
                label="Enable Direct Chat and Video"
                :disable="adminRole !== 'admin'"
              />
              <div v-if="isMyTech === 'yes'" class="ac-input-container pl-12">
                <p class="custom-bullet">
                  Options will be
                  <span
                    :style="{ color: isMyTech === 'yes' ? $NBLUE90 : 'black' }"
                  >visible</span>
                  in <span>Member & Pro Apps</span>
                </p>
                <p class="custom-bullet">
                  Options will be
                  <span
                    :style="{ color: isMyTech === 'yes' ? $NBLUE90 : 'black' }"
                  >visible</span>
                  in the <span>Partner Dashboard</span>
                </p>
                <p class="custom-bullet">
                  If no technician has this feature enabled, communications will
                  route to <span>Admin Accountname</span>
                </p>
              </div>
            </div>
            <div>
              <SACRadio
                name="handle-tech"
                field="isMyTech"
                value="no"
                :checked="isMyTech === 'no'"
                :change="onChange"
                label="Disable Direct Chat and Video"
                :disable="adminRole !== 'admin'"
              />
              <div v-if="isMyTech === 'no'" class="ac-input-container pl-12">
                <p class="custom-bullet">
                  Options will be
                  <span :style="{ color: isMyTech === 'no' ? 'red' : 'black' }">hidden</span>
                  in <span>Member & Pro Apps</span>
                </p>
                <p class="custom-bullet">
                  Options will be
                  <span :style="{ color: isMyTech === 'no' ? 'red' : 'black' }">hidden</span>
                  in the <span>Partner Dashboard</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-row just-end">
        <div class="flex-row mt-4">
          <div class="flex-column pt-4">
            <MyTechPreview :isMyTech="isMyTech" :partnerName="partnerName" />
            <div class="pc-preview-title text-center">
              Home Screen
            </div>
            <div class="sac__font-12 n60 text-center">
              Pro App
            </div>
          </div>
          <div class="flex-column pt-5 pl-5 pr-5" style="position: relative">
            <div class="pc-preview-background" :style="backgroundStyles">
              <img
                v-if="isMyTech === 'yes'"
                src="@shared/assets/img/partner-detail/member-home-ch.png"
                height="520"
                width="240"
                alt="Home Screen"
              />
              <img
                v-else
                src="@shared/assets/img/partner-detail/member-home.png"
                height="520"
                width="240"
                alt="Pro App"
              />
              <div v-if="partnerSettings.LOGO_URL" class="pc-logo-container">
                <img :src="partnerSettings.LOGO_URL" class="pc-logo-img" alt="Logo" />
              </div>
            </div>
            <div class="pc-preview-title text-center">
              Home Screen
            </div>
            <div class="sac__font-12 n60 text-center">
              Member App
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import partnerSettingsMixin from '@shared/mixins/partnerSettingsMixin';

import MyTechPreview from '@shared/components/partnerSettings/myTech/MyTechPreview.vue';
import SACRadio from '@shared/components/sac/SACRadio.vue';

export default {
  name: 'MyTech',
  components: {
    MyTechPreview,
    SACRadio,
  },
  mixins: [partnerSettingsMixin],
  props: {
    isMyTech: String,
    partnerName: String,
    partnerSettings: Object,
    onChange: Function,
    errorObj: Object,
  },
  computed: {
    backgroundStyles() {
      return {
        'background-color': this.partnerSettings.PRIMARY_COLOR,
        display: 'flex',
        'justify-content': 'flex-end',
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-bullet {
  position: relative;
  padding-left: 20px;
  span {
    color: $NBLUE90;
  }
  span:nth-of-type(2) {
    font-weight: bold;
    color: black;
  }
}
.pc-preview-background {
  border-radius: 50px;
}
.pc-logo-container {
  position: absolute;
  top: 40px;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  .pc-logo-img {
    width: 160px;
    height: 160px;
    z-index: 1;
    object-fit: contain;
  }
}
.custom-bullet::before {
  content: '•';
  position: absolute;
  left: 0;
  top: 0;
  color: black;
}

.ac-row-container {
  display: flex;
  justify-content: space-between;
}

.filter-options {
  display: grid;
  gap: 8px;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 8px;
  cursor: pointer;
  max-height: 250px;
}

.header {
  font-size: 1rem;
  font-weight: 700;
  color: $N80;
}

.sub-header {
  font-size: 1rem;
  font-weight: 500;
  color: $N60;
  margin-bottom: 24px;
}

.ac-upload-wrapper {
  width: 49%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
}

.blue-underline {
  text-decoration: underline;
  color: $NBLUE100;
  font-weight: 600;
  cursor: pointer;
}

.ac-centered-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.ac-preview-container {
  margin-bottom: 50px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  .ac-logo-preview-container {
    border-radius: 9px;
    width: 183px;
    height: 183px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;

    img {
      width: 100%;
    }
  }

  .ac-edit-image-btn {
    background-color: $NBLUE100;
    color: $WHITE;
    width: 36px;
    height: 36px;
    border-radius: 4px;
    padding: 5px;
    margin-right: 16px;

    img {
      width: 100%;
      object-fit: contain;
    }
  }

  .ac-change-image-btn {
    background-color: $NBLUE100;
    height: 36px;
    color: $WHITE;
    font-size: 0.875rem;
    font-weight: 600;
    border-radius: 4px;
    padding: 0 12px;
    cursor: pointer;
    white-space: nowrap;
  }
}
</style>
